export default __webpack_public_path__ + "static/media/020-carrots.7a65eef9.svg";